/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createUnitCost } from '../fn/unit-costs/create-unit-cost';
import { CreateUnitCost$Params } from '../fn/unit-costs/create-unit-cost';
import { deleteUnitCost } from '../fn/unit-costs/delete-unit-cost';
import { DeleteUnitCost$Params } from '../fn/unit-costs/delete-unit-cost';
import { getUnitCost } from '../fn/unit-costs/get-unit-cost';
import { GetUnitCost$Params } from '../fn/unit-costs/get-unit-cost';
import { listUnitCosts } from '../fn/unit-costs/list-unit-costs';
import { ListUnitCosts$Params } from '../fn/unit-costs/list-unit-costs';
import { UnitCostDto } from '../models/unit-cost-dto';
import { UnitCostDtoPage } from '../models/unit-cost-dto-page';
import { updateUnitCost } from '../fn/unit-costs/update-unit-cost';
import { UpdateUnitCost$Params } from '../fn/unit-costs/update-unit-cost';

@Injectable({ providedIn: 'root' })
export class UnitCostsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listUnitCosts()` */
  static readonly ListUnitCostsPath = '/v0/unitCosts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listUnitCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitCosts$Response(params?: ListUnitCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDtoPage>> {
    return listUnitCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listUnitCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listUnitCosts(params?: ListUnitCosts$Params, context?: HttpContext): Observable<UnitCostDtoPage> {
    return this.listUnitCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostDtoPage>): UnitCostDtoPage => r.body)
    );
  }

  /** Path part for operation `getUnitCost()` */
  static readonly GetUnitCostPath = '/v0/unitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUnitCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitCost$Response(params: GetUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDto>> {
    return getUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUnitCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUnitCost(params: GetUnitCost$Params, context?: HttpContext): Observable<UnitCostDto> {
    return this.getUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostDto>): UnitCostDto => r.body)
    );
  }

  /** Path part for operation `updateUnitCost()` */
  static readonly UpdateUnitCostPath = '/v0/unitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUnitCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitCost$Response(params: UpdateUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUnitCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateUnitCost(params: UpdateUnitCost$Params, context?: HttpContext): Observable<void> {
    return this.updateUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createUnitCost()` */
  static readonly CreateUnitCostPath = '/v0/unitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createUnitCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnitCost$Response(params: CreateUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDto>> {
    return createUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createUnitCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createUnitCost(params: CreateUnitCost$Params, context?: HttpContext): Observable<UnitCostDto> {
    return this.createUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<UnitCostDto>): UnitCostDto => r.body)
    );
  }

  /** Path part for operation `deleteUnitCost()` */
  static readonly DeleteUnitCostPath = '/v0/unitCosts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteUnitCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUnitCost$Response(params: DeleteUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteUnitCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteUnitCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteUnitCost(params: DeleteUnitCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteUnitCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
